import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ServicePageWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
`;

export const ServiceHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
  background: linear-gradient(135deg, #2F4F4F 0%, #1c2f2f 100%);
  padding: 4rem 2rem;
  border-radius: 24px;
  color: white;
`;

export const ServiceTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  color: #D4B996;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const ServiceDescription = styled.p`
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const ServiceContent = styled.div`
  margin-top: 4rem;
`;

export const ServiceSection = styled.section`
  margin-bottom: 3rem;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  &:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-5px);
    transition: all 0.3s ease;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2rem;
  color: #2F4F4F;
  margin-bottom: 1.5rem;
  
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const SectionText = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
`;

export const BenefitsList = styled.ul`
  list-style: none;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 16px;
  margin: 3rem 0;
`;

export const BenefitItem = styled.li`
  font-size: 1.1rem;
  margin-bottom: 1rem;
  padding-right: 2rem;
  position: relative;
  color: #2F4F4F;
  
  &:before {
    content: '✓';
    position: absolute;
    right: 0;
    color: #8B7355;
    font-weight: bold;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const CTASection = styled.div`
  text-align: center;
  margin-top: 4rem;
  padding: 3rem;
  background: linear-gradient(135deg, #8B7355 0%, #D4B996 100%);
  border-radius: 24px;
  color: white;
`;

export const CTAText = styled.h3`
  font-size: 2rem;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    font-size: 1.6rem;
  }
`;

export const CTAButton = styled(motion.button)`
  background: white;
  color: #8B7355;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.2rem;
  border-radius: 50px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  svg {
    font-size: 1.5rem;
  }
`;

export const FAQSection = styled.div`
  margin: 4rem 0;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 16px;
`;

export const FAQTitle = styled.h2`
  font-size: 2.2rem;
  color: #2F4F4F;
  text-align: center;
  margin-bottom: 2rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    right: 50%;
    transform: translateX(50%);
    width: 80px;
    height: 3px;
    background: #8B7355;
  }
`;

export const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FAQItem = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const FAQQuestion = styled.div`
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: #2F4F4F;
  background: ${props => props.isOpen ? '#f8f9fa' : 'white'};
  
  svg {
    transition: transform 0.3s ease;
  }
`;

export const FAQAnswer = styled.div`
  padding: ${props => props.isOpen ? '1.5rem' : '0 1.5rem'};
  max-height: ${props => props.isOpen ? '500px' : '0'};
  opacity: ${props => props.isOpen ? '1' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  line-height: 1.6;
  color: #666;
  border-right: 3px solid ${props => props.isOpen ? '#8B7355' : 'transparent'};
  margin-right: 1.5rem;
`; 